// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorm-reporting-and-atc.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorm-reporting-and-atc/thunderstorm-reporting-and-atc.js';

mount([g0]);
